import React, { Component } from "react";

class ReporteFormato1 extends Component {
  render() {
    return (
      <div>
        <fieldset className="col-md-12">
          <legend>Datos exportación</legend>

          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label>
                  Producto: <span className="text-danger"> *</span>
                </label>
                <select
                  name="bitacora_id"
                  id="bitacora_id"
                  onChange={this.props.component.handleCambioFormulario1}
                  value={this.props.state.reporte_1.bitacora_id}
                  className="form-control"
                >
                  <option value="">Seleccione</option>
                  {this.props.state.option_productos.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.nombre_comercial} (Cant. {option.cantidad}) 
                      [{option.fecha_hora_salida.split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("-")
                          .replaceAll("-", "/")}-
                          {option.fecha_hora_salida.split(" ")[1].substr(0,5)}]
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="no_factura_exportacion">
                  No. de factura de Exportación:{" "}
                  <span className="text-danger"> *</span>
                </label>

                <input
                  type="text"
                  name="no_factura_exportacion"
                  id="no_factura_exportacion"
                  maxLength={25}
                  onChange={this.props.component.handleCambioFormulario1}
                  value={this.props.state.reporte_1.no_factura_exportacion}
                  className="form-control"
                  placeholder="Ingrese número de factura de exportación"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="no_certificado_exportacion">
                  No. de certificado de exportación:{" "}
                  <span className="text-danger"> *</span>
                </label>

                <input
                  type="text"
                  name="no_certificado_exportacion"
                  id="no_certificado_exportacion"
                  maxLength={25}
                  onChange={this.props.component.handleCambioFormulario1}
                  value={this.props.state.reporte_1.no_certificado_exportacion}
                  className="form-control"
                  placeholder="Ingrese número de certificado de exportación"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label htmlFor="aduana">
                  Nombre de la aduana en que exportó la sustancia o producto:{" "}
                  <span className="text-danger"> *</span>
                </label>

                <input
                  type="text"
                  name="aduana"
                  id="aduana"
                  maxLength={150}
                  onChange={this.props.component.handleCambioFormulario1}
                  value={this.props.state.reporte_1.aduana}
                  className="form-control"
                  placeholder="Ingrese nombre de la aduana"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="fecha_ingreso_aduana">
                  Fecha de ingreso en aduana:{" "}
                  <span className="text-danger"> *</span>
                </label>

                <input
                  type="date"
                  name="fecha_ingreso_aduana"
                  id="fecha_ingreso_aduana"
                  onChange={this.props.component.handleCambioFormulario1}
                  value={this.props.state.reporte_1.fecha_ingreso_aduana}
                  className="form-control"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="fecha_exportador_aduana">
                  Fecha de egreso en bodega del establecimiento exportador:{" "}
                  <span className="text-danger"> *</span>
                </label>

                <input
                  type="date"
                  name="fecha_exportador_aduana"
                  id="fecha_exportador_aduana"
                  onChange={this.props.component.handleCambioFormulario1}
                  value={this.props.state.reporte_1.fecha_exportador_aduana}
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="btn-group pull-right col-lg-2">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={this.props.component.addReporte1}
                >
                  Agregar
                </button>
              </div>
            </div>
          </div>
          <hr />

          <div className="table-responsive">
            <table className="table table-striped m-b-0 table-hover">
              <thead>
                <tr>
                  <th className="text-center">Producto</th>
                  <th className="text-center">Número factura</th>
                  <th className="text-center">Número certificado</th>
                  <th className="text-center">Cantidad</th>
                  <th className="text-center">Nombre aduana</th>
                  <th className="text-center">Ingreso aduana</th>
                  <th className="text-center">Egreso en bodega</th>
                  <th className="text-center"> </th>
                </tr>
              </thead>
              <tbody>
                {this.props.state.productos.length > 0 ? (
                  this.props.state.productos.map((pro, index) => (
                    <tr key={index} id={index}>
                      <td className="text-center">{pro.nom_producto}</td>
                      <td className="text-center">
                        {pro.no_factura_exportacion}
                      </td>
                      <td className="text-center">
                        {pro.no_certificado_exportacion}
                      </td>
                      <td className="text-center">{pro.cantidad}</td>
                      <td className="text-center">{pro.aduana}</td>
                      <td className="text-center">
                        {pro.fecha_ingreso_aduana.split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("-")
                          .replaceAll("-", "/")}
                      </td>
                      <td className="text-center">
                        {pro.fecha_exportador_aduana.split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("-")
                          .replaceAll("-", "/")}
                      </td>
                      <td className="text-center">
                        <div
                          className="btn btn-warning remover-producto"
                          id={index}
                          title="Remover"
                          data-id={pro.producto_id}
                          data-nombre={pro.nom_producto}
                          data-bitacora_id={pro.bitacora_id}
                          data-cantidad={pro.cantidad}
                          onClick={this.props.component.removeReporte1}
                        >
                          <i
                            className="fas fa-trash"
                            id={index}
                            title="Remover"
                            data-id={pro.producto_id}
                            data-nombre={pro.nom_producto}
                            data-bitacora_id={pro.bitacora_id}
                            data-cantidad={pro.cantidad}
                            onClick={this.props.component.removeReporte1}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center">No hay productos</td>
                    <td className="text-left"></td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                    <td className="text-center"></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </fieldset>
      </div>
    );
  }
}

export default ReporteFormato1;
